import cx from 'clsx';

import { LINK_REL_DEFAULT_LIST } from './constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const TextLink: Component = ({
  className,
  href,
  text,
  rel = LINK_REL_DEFAULT_LIST.join(' '),
  target,
  onClick,
}) => (
  <a
    className={cx(
      className,
      styles.linkRoot,
    )}
    href={href}
    rel={rel}
    target={target}
    onClick={onClick}>
    {text}
  </a>
);
